import CryptoJS from "crypto-js";
import axios from "axios";

const state = {
  host: "localhost",
  proto: "https://",
  pwResetUrl: "/pwReset",
  project: "iam-test",
  apiHost: "directus.iam-design.de",
  customUploads: "https://directus.iam-design.de/public/kommtool/files",
  serverInfo: false,
  defaultAvatar: 1193,
  url() {
    return this.proto + this.apiHost + "/" + this.project;
  },
  tokenLifeTime: 5,
  isAuthenticated: false,
  lastAuthCheck: false,
  isAdmin: false,
  authCheckThreshold: 5 * 60 * 1000,
  authHeader() {
    return { headers: { Authorization: "bearer " + this.token } };
  },
  loginError: false,
  loginErrorMsg: false,
  status: "initial",
  endpoint: {
    auth: "/auth/authenticate",
    files: "/files",
    users: "/users",
    me: "/users/me",
    reqPwReset: "/auth/password/request",
    resetPw: "/auth/password/reset",
    refresh: "/auth/refresh",
    mail: "/mail",
  },
  user: false,
  userPw: false,
  userPwPlain: false,
  userImg: false,
  userImgFormats: {},
  userRole: false,
  uploadProgress: 0,
  pwResetRequested: false,
  kundeOfUser: false,
  connection: {
    monitoring: null,
    lastPingResult: null,
    projectInfo: null,
    userInfo: null,
    checkInterval: null,
    checkIntervalTime: 10000,
    connectionRating: null,
  },
};

const defaultState = Object.assign({}, state);

const getters = {
  apiSettings: (state) => {
    return {
      url: state.url(),
      authHeader: state.authHeader(),
      endpoint: state.endpoint,
      customUploads: state.customUploads,
      apiHost: state.apiHost,
    };
  },
  apiToken: (state) => state.token,
  isAuth: (state) => state.isAuthenticated,
  apiStatus: (state) => state.status,
  loginError: (state) => state.loginError,
  userImg: (state) => state.userImg,
  userImgFormats: (state) => state.userImgFormats,
  user: (state) => state.user,
  userRole: (state) => state.userRole,
  pwResetRequested: (state) => state.pwResetRequested,
  uploadProgress: (state) => state.uploadProgress,
  isAdmin: (state) => state.isAdmin,
  serverInfo: (state) => state.serverInfo,
  lastAuthCheck: (state) => state.lastAuthCheck,
  authCheckThreshold: (state) => state.authCheckThreshold,
  kou: (state) => state.kundeOfUser,
  defaultAvatar: (state) => state.defaultAvatar,
  connection: (state) => state.connection,
};

const actions = {
  genPW() {
    return Math.random()
      .toString(36)
      .slice(-8);
  },
  handleConnectionLost() {
    console.log("=========== handle connection lost was called ==============");
  },
  startConnectionMonitoring({ dispatch, commit }) {
    if (!state.connection.monitoring) {
      setInterval(startIt(), state.connection.checkIntervalTime);
    }
    function startIt() {
      dispatch("checkConnection");
      commit("startConnectionMonitoring");
    }
  },
  async checkConnection({ commit, dispatch }) {
    if (!state.isAuthenticated) {
      commit("clearConnectionInterval");
    }

    const pingStart = new Date();
    try {
      const pingResponse = await this._vm.$directus.ping();
      if (pingResponse !== "pong") dispatch("handleConnectionLost");
      if (state.isAuthenticated) {
        setTimeout(function() {
          dispatch("checkConnection");
        }, 5000);
      }
    } catch (err) {
      console.log("Error Pinging");
      dispatch("handleConnectionLost");
    }
    const pingEnd = new Date();
    const pingDiff = pingEnd - pingStart;

    commit("setLastPing", pingDiff);
    await dispatch("computeConnectionRating");

    if (!state.connection.projectInfo) {
      const pInfo = await this._vm.$directus.projectInfo();
      commit("setProjectInfo", pInfo);
    }
    if (!state.connection.userInfo) {
      const uInfo = await this._vm.$directus.getMe();
      commit("setUserInfo", uInfo);
    }
  },
  computeConnectionRating({ commit }) {
    if (state.connection.lastPingResult < 400) commit("setConnectionRating", "green");
    if (state.connection.lastPingResult > 400 && this.lastPingResult < 1200) commit("setConnectionRating", "yellow");
    if (state.connection.lastPingResult > 1200) commit("setConnectionRating", "red");
  },
  async logout({ commit, dispatch }) {
    await dispatch("disableTokenRefreshInterval");
    this._vm.$directus.logout();
    commit("logout");
  },
  encryptPw({ commit }, creds) {
    let encrypted = false;
    try {
      encrypted = CryptoJS.AES.encrypt(creds, "iampwcrypt").toString();
    } catch (error) {
      console.log(error);
      throw error;
    }
    commit("setEncPw", encrypted);
  },
  decryptPw() {
    let decryptBytes = false;
    try {
      decryptBytes = CryptoJS.AES.decrypt(state.userPw, "iampwcrypt");
      let decryptString = decryptBytes.toString(CryptoJS.enc.Utf8);
      return decryptString;
    } catch (error) {
      console.log(error);
    }
  },
  async reqPwReset({ commit }, email) {
    try {
      await this._vm.$directus.requestPasswordReset(email, state.host + state.pwResetUrl);
      commit("setPwResetState");
    } catch (error) {
      throw error;
    }
  },
  async resetPw(_, payload) {
    try {
      await this._vm.$directus.resetPassword(payload.password, payload.token);
    } catch (error) {
      throw error;
    }
  },
  async checkIfLoggedIn() {
    /*
        const storageExists = this._vm.$directus.api.config.token;
        if (storageExists) {
            console.log("found token, checking");
            try {
                const checkValid = await this._vm.$directus.getMe();
                console.log("output checkValid: ");
                console.log(checkValid);
                commit("initUser", checkValid.data);
                commit("refreshAuthCheck");
                if (checkValid.data.avatar) await dispatch("getUserImg", checkValid.data.avatar);
                return true;
            } catch (error) {
                console.log('token is invalid, returning to Login Page');
                dispatch("setDefaultState");
                commit("logout");
                this.$router.push("/");
            }
        } else {
            console.log('no token found or token invalid');
            return false;
        }*/
    return state.isAuthenticated;
  },
  async login({ commit, dispatch }, credentials) {
    state.loginError = false;
    try {
      let response = await this._vm.$directus.login({
        email: credentials.email,
        password: credentials.password,
        persist: true,
      });
      commit("initUser", response.data.user);
      commit("loginSuccess");
      dispatch("manageTokenRefresh");

      if (response.data.user.role == 3) {
        await dispatch("getKundeOfUser", response.data.user.id);
        await dispatch("handleLastLogin");
        await dispatch("getUserImg", state.kundeOfUser.image);
      } else {
        if (response.data.user.avatar) await dispatch("getUserImg", response.data.user.avatar);
      }
    } catch (error) {
      console.log(error);
      commit("loginFailure", error);
    }
  },
  async handleLastLogin({ dispatch }) {
    try {
      //prepare Date
      const dOptions = { weekday: "short", year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" };
      const now = new Date();
      const localized = now.toLocaleDateString("de-DE", dOptions);

      //check if logged in before
      if (state.kundeOfUser.last_login == null || state.kundeOfUser.last_login == "") {
        await dispatch("sendLastLoginMail", localized);
      }

      const payload = {
        collection: "kunde",
        item: state.kundeOfUser.id,
        changes: {
          last_login: localized,
        },
      };
      await dispatch("app/mutate", payload, { root: true });
    } catch (err) {
      console.log(err);
      throw "Fehler beim Aktualisieren des Login Status.";
    }
  },
  async sendLastLoginMail(_, logindate) {
    const token = JSON.parse(localStorage.getItem("directus-sdk-js")).token;
    const url = "https://directus.iam-design.de/public/iam-test/mail";
    const options = {
      headers: {
        Authorization: "bearer " + token,
      },
    };

    const subject = `${state.kundeOfUser.first_name} ${state.kundeOfUser.last_name} hat sich im Portal angemeldet`;
    const data = {
      to: "admins@infrabau-portal.de",
      from: "no-reply@infrabau-portal.de",
      subject: subject,
      body: `
          Hallo, <br/>
          <br />
          <span style='margin-top:20px; margin-bottom:20px;'>
          der Kunde ${state.kundeOfUser.first_name} ${state.kundeOfUser.last_name} hast sich zum ersten Mal im Portal angemeldet, der Zeitstempel lautet ${logindate}.          
          <br /><br />          
          <br /><br />
          <span style='margin-top:20px; margin-bottom:20px;'Infrabau Portal Mailer</span>
          `,
      type: "html",
      data: {
        vorname: state.kundeOfUser.first_name,
        nachname: state.kundeOfUser.last_name,
        login: logindate,
      },
    };

    try {
      const response = await axios.post(url, data, options);
      console.log("mail sent");
      console.log(response);
    } catch (error) {
      console.log("error when sending last login mail");
      console.log(error);
    }
  },
  async manageTokenRefresh({ dispatch }) {
    try {
      state.refreshInterval = setInterval(function() {
        dispatch("refreshToken");
      }, 10000);
    } catch (error) {
      console.log(error);
      console.log("error in manageTokenRefresh");
    }
  },
  async refreshToken() {
    const newToken = await this._vm.$directus.refresh(this._vm.$directus.api.config.token);
    this._vm.$directus.api.config.token = newToken.data.token;
  },
  disableTokenRefreshInterval() {
    clearInterval(state.refreshInterval);
  },
  async getKundeOfUser({ commit }, userId) {
    const filter = {
      filter: {
        user: userId,
      },
    };
    try {
      const responseKunde = await this._vm.$directus.getItems("kunde", filter);
      commit("setKundeOfUser", responseKunde.data[0]);
    } catch (error) {
      console.log(error);
      throw "Fehler beim Laden des Kundenbenutzers";
    }
  },
  async getUserImg({ commit }, id) {
    //Temporary Fix needs removal
    if (id == null) id = 1192;
    //temporary end
    id = id.toString();
    try {
      let response = await this._vm.$directus.getFile(id);
      commit("setUserImg", response.data.data);
    } catch (error) {
      console.log("error fetching image");
      console.log(error);
    }
  },
  async uploadImage({ dispatch }, upload) {
    try {
      const response = await this._vm.$directus.uploadFiles(upload.image, function onUploadProgress(prgEvent) {
        console.log(prgEvent);
      });
      const metadata = {
        tags: ["user_profile_image"],
      };
      await this._vm.$directus.updateItem("directus_files", response.data.id, metadata);
      dispatch("mutateUser", { avatar: response.data.id });
      dispatch("getUserImg", response.data.id);
    } catch (error) {
      console.log(error);
    }
  },
  async mutateUser({ commit }, changes) {
    try {
      let response = await this._vm.$directus.updateUser(state.user.id, changes);
      commit("initUser", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  initUpdateUser({ commit }, changes) {
    commit("updateUserState", changes);
  },
  debug() {
    console.log(defaultState);
  },
  setDefaultState({ commit }) {
    commit("app/setDefaultState", null, { root: true });
    commit("logout");
  },
};

const mutations = {
  loginSuccess: (state) => {
    state.isAuthenticated = true;
    state.lastAuthCheck = new Date();
    state.loginErrorMsg = false;
    state.loginError = false;
    if (state.user.role == "1") state.isAdmin = true;
  },
  refreshAuthCheck: (state) => {
    state.lastAuthCheck = new Date();
  },
  loginFailure: (state, error) => {
    state.isAuthenticated = false;
    state.loginError = true;
    state.loginErrorMsg = error;
  },
  initUser: (state, user) => {
    state.user = user;
  },
  setUserImg: (state, img) => {
    state.userImgFormats = img.thumbnails;
    state.userImg = img.thumbnails[0];
  },
  updateUserState(state, newState) {
    Object.assign(state.user, newState);
  },
  logout: (state) => {
    state.isAuthenticated = false;
    console.log(state.isAuthenticated);
    state = {};
  },
  setEncPw: (state, pw) => {
    state.userPw = pw;
  },
  setPlainPw: (state, pw) => {
    state.userPwPlain = pw;
  },
  setPwResetState: (state) => {
    state.pwResetRequested = true;
  },
  setKundeOfUser: (state, kou) => {
    state.kundeOfUser = kou;
  },
  clearConnectionInterval: (state) => {
    clearInterval(state.connection.checkInterval);
    state.connection.checkConnection = false;
    state.connection.monitoring = false;
  },
  setLastPing: (state, ping) => {
    state.connection.lastPingResult = ping;
  },
  setConnectionRating: (state, rating) => {
    state.connection.connectionRating = rating;
  },
  setUserInfo: (state, info) => {
    state.connection.userInfo = info;
  },
  setProjectInfo: (state, info) => {
    state.connection.projectInfo = info;
  },
  startConnectionMonitoring: (state) => {
    state.connection.monitoring = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
